import EnderecoBusiness from "@/business/EnderecoBusiness";
import CachedApi from "@/commons/CachedApi.js";
import Http, {source} from "@/commons/Http";
import Utils from "@/commons/Utils.js";
import VueBusiness from "@/business/VueBusiness";

const path = 'api/indicador-pessoal';

let cancelSource;
const cancelSearch = () => {
  if (cancelSource) {
    cancelSource.cancel();
  }
}

export const tratarAto = (a) => {

  a.tipoServico = JSON.parse(a.tipoServico);
  if(a.tipoServico?.opcoes && typeof a.tipoServico?.opcoes === 'string'){
    a.tipoServico.opcoes = JSON.parse(a.tipoServico.opcoes || false)
  }
  a.ato = a.ato ? JSON.parse(a.ato) : undefined;

  a.indicador = JSON.parse(a.indicador || false);
  (a.indicador?.id) ? '' : a.indicador = undefined;

  a.registroAuxiliar = JSON.parse(a.registroAuxiliar || false);
  (a.registroAuxiliar?.id) ? '' : a.registroAuxiliar = undefined;

  a.indicadorReal = JSON.parse(a.indicadorReal || false);
  (a.indicadorReal?.id) ? '' : a.indicadorReal = undefined;

  // Ato do Livro 3 (RJ) carrega indicadorReal como VÍNCULO: a ficha do ato continua sendo o registro auxiliar.
  a.ficha = a.registroAuxiliar || a.indicadorReal || a.indicador;

  if(a.validador) a.validador = JSON.parse(a.validador);


  return a;

};

const tratarAtoVersao = (a) => {

  a.tipoServico = JSON.parse(a.tipoServico);
  if(a.tipoServico?.opcoes && typeof a.tipoServico?.opcoes === 'string'){
    a.tipoServico.opcoes = JSON.parse(a.tipoServico.opcoes || false)
  }
  a.dto = JSON.parse(a.dto);

  a.indicador = JSON.parse(a.indicador || false);
  (a.indicador?.id) ? '' : a.indicador = undefined;

  a.registroAuxiliar = JSON.parse(a.registroAuxiliar || false);
  (a.registroAuxiliar?.id) ? '' : a.registroAuxiliar = undefined;

  a.indicadorReal = JSON.parse(a.indicadorReal || false);
  (a.indicadorReal?.id) ? '' : a.indicadorReal = undefined;

  // Ato do Livro 3 (RJ) carrega indicadorReal como VÍNCULO: a ficha do ato continua sendo o registro auxiliar.
  a.ficha = a.registroAuxiliar || a.indicadorReal || a.indicador;

  return a;

};

let cacheTime = '';

export default {

  async pagination(sort, direction, page, size, filters = {}) {
    return Http.post(`${path}/pagination?sort=${sort || 'v.nome'},${direction || 'asc'}&page=${page || 1}&size=${size || 10}`, filters);
  },

  async paginationV2(sort, direction, page, size, filters = {}) {
    return Http.post(`${path}/v2/pagination?sort=${sort || 'v.nome'},${direction || 'asc'}&page=${page || 1}&size=${size || 10}`, filters);
  },

  async getVersaoById(id) {
    if(!Utils.testUUID(id)){
      return Promise.reject();
    }
    return Http.get(`${path}/versao/${id}`);
  },

  async listarHistoricoBib(indicadorPessoalId, sortBy, sortDir, pageNumber, pageLength) {
    return Http.post(`${path}/${indicadorPessoalId}/bib?sort_by=${sortBy}&sort_dir=${sortDir}&page_number=${pageNumber}&page_length=${pageLength}`);
  },

  async possuiIndisponibilidades(id) {
    if(!Utils.testUUID(id)){
      return Promise.reject();
    }
    return CachedApi.getCached('indisponibilidades-'+id, async () => {
      return Http.get(`${path}/${id}/possui-indisponibilidades`);
    });
  },

  async possuiPep(id) {
    if(!Utils.testUUID(id)){
      return Promise.reject();
    }
    return CachedApi.getCached('pep-'+id, async () => {
      return Http.get(`${path}/${id}/possui-pep`);
    });
  },

  async possuiSaldoPendente(id, protocolo) {
    return Http.get(`${path}/${id}/possui-saldo-pendente${protocolo ? '/'+protocolo :''}`);
  },

  resetCache(){
    cacheTime = Utils.uuid();
  },

  async getVersaoByIdComCache(id) {
    if(!Utils.testUUID(id)){
      return Promise.reject();
    }
    return CachedApi.getCached('versao-'+id, async () => {
      return Http.get(`${path}/versao/${id}/cache?resetCache=${cacheTime}`);
    });
  },

  async getById(id) {
    if(!Utils.testUUID(id)){
      return Promise.reject();
    }
    return Http.get(`${path}/${id}`);
  },

  async getVersoes(id) {
    if(!Utils.testUUID(id)){
      return Promise.reject();
    }
    return Http.get(`${path}/${id}/versoes`).then(l => l.map(tratarAto));
  },

  async getVersoesAll(id) {
    if(!Utils.testUUID(id)){
      return Promise.reject();
    }
    return Http.get(`${path}/${id}/versoes-all`);
  },

  async permiteRemover(id) {
    return Http.get(`${path}/versao/${id}/permite-remover`);
  },

  async deleteByIdVersao(id){
    if(!Utils.testUUID(id)){
      return Promise.reject();
    }
    return Http.delete(`${path}/versao/${id}`);
  },

  async updateVersaoAtual(id, versaoId, versao){
    if(!Utils.testUUID(id) || !Utils.testUUID(versaoId) || !(versao || versao === 0)){
      return Promise.reject();
    }
    return Http.get(`${path}/${id}/versao/${versaoId}/${versao}`);
  },

  async getDocumentosDuplicados(id) {
    if(!Utils.testUUID(id)){
      return Promise.reject();
    }
    return Http.get(`${path}/${id}/documentos-duplicados`);
  },

  async getQtdDocumentosDuplicados(id) {
    if(!Utils.testUUID(id)){
      return Promise.reject();
    }
    return Http.get(`${path}/${id}/qtd-documentos-duplicados`);
  },

  async mergeDocuments(id, lista){
    if(!Utils.testUUID(id)){
      return Promise.reject();
    }
    return Http.post(`${path}/${id}/merge`, lista);
  },

  async buscarAtosRegistrados(id, tipo) {
    return Http.get(`${path}/${id}/atos-registrados/${tipo}`).then(l => l.map(tratarAto));
  },

  async buscarAtosRegistradosPaginado(id, tipo, sortBy, sortDir, page, size) {
    return Http.get(`${path}/${id}/atos-registrados/${tipo}/pagination?sort=${sortBy || 'v.codigo_indicador'},${sortDir || 'asc'}&page=${page || 0}&size=${size || 20}`);
  },

  async buscarAtosRegistradosPJ(documento, atribuicao) {
    let params = new URLSearchParams();
    params.set("documento",documento);
    params.set("atribuicao",atribuicao);
    return Http.get(`${path}/atos-registrados-pj`,{params});
  },

  async buscarUltimaAuditoriaImpressaoAto(id){
    return Http.get(`${path}/${id}/ultima-auditoria-impressao`);
  },

  async buscarAtosVersao(id) {
    return Http.get(`${path}/${id}/atos-versao`).then(l => l.map(tratarAtoVersao));
  },

  async buscarProtocolosAtivos(id) {
    return Http.get(`${path}/${id}/protocolos-ativos`);
  },

  async buscarPropriedadesAtuais(id){
    return Http.get(`${path}/${id}/propriedades-atuais`);
  },

  async buscarPropriedadesAtuaisPorDocumento(documento){
    return Http.get(`${path}/buscar-propriedades-atuais/${documento}`);
  },

  async buscarExPropriedades(id) {
    return Http.get(`${path}/${id}/ex-propriedades`);
  },

  async sugerir(filters) {
    cancelSearch();
    cancelSource = source.source();
    let retorno;
    await Http.post(`${path}/sugerir`, filters, { cancelToken: cancelSource.token }).then((response) => {
      if (response) {
        retorno = response;
        cancelSource = null;
      }
    });
    return retorno;
  },

  async sugerirProfissao(query) {
    return Http.get(`${path}/sugerir/profissao/${query}`);
  },

  async validarDadosAlteracaoIndicador(dto){
    return Http.post(`${path}/validar-dados-alteracoes-indicador`, dto);
  },

  async validarDadosCadastroIndicador(indicador){
    return Http.post(`${path}/validar-dados-cadastro-indicador`, indicador);
  },

  async getRestricoes(indicadorPessoalId) {
    return Http.get(`${path}/restricoes/${indicadorPessoalId}`);
  },

  async getRegistrosAuxiliares(indicadorPessoalId) {
    return Http.get(`${path}/registros-auxiliares/${indicadorPessoalId}`);
  },

  async criarIndicador(dto) {
    return Http.post(`${path}`, dto);
  },

  async criarVersao(id, editar = false, dto) {
    return Http.post(`${path}/${id}/${editar}`, dto);
  },

  async getErrosTomador(indicadorPessoalVersaoId) {
    return Http.get(`${path}/tomador/erros/${indicadorPessoalVersaoId}`);
  },

  async getVinculoSiscoaf(indicadorPessoalVersaoId) {
    return Http.get(`${path}/versao/${indicadorPessoalVersaoId}/vinculo-siscoaf`);
  },

  async validarNome(nome, tipoPessoa) {
    if(nome) {
      if(tipoPessoa) {
        return Http.get(`${path}/public/validar/nome/${tipoPessoa}/${nome.replace('/', '')}`);
      }
      return Http.get(`${path}/public/validar/nome/${nome.replace('/', '')}`);
    }
    return "Nome inválido!";
  },

  async validarDocumentos(tipoPessoa, nrDocumento, permiteNove = false) {
    let doc = (nrDocumento || '').replace(/[^a-zA-Z0-9]/g, "").trim().toUpperCase();

    if(!tipoPessoa){
      tipoPessoa = doc.length > 11 ? 'JURIDICA' : 'FISICA';
    }
    if (doc) {
      return Http.get(`${path}/public/validar/documento/${tipoPessoa}/${doc}/${permiteNove}`);
    }
    return "Documento inválido!";
  },

  getNaturezaJuridica() {
    return [
      {id: 'DIREITO_PRIVADO', nome: 'Pessoa Jurídica de Direito Privado'},
      {id: 'DIREITO_PUBLICO', nome: 'Pessoa Jurídica de Direito Público'},
      {id: 'AUTARQUIA_FEDERAL', nome: 'Autarquia Federal'},
      {id: 'AUTARQUIA_ESTADUAL', nome: 'Autarquia Estadual'},
      {id: 'AUTARQUIA_MUNICIPAL', nome: 'Autarquia Municipal'},
      {id: 'EMPRESA_PUBLICA', nome: 'Empresa Pública'},
      {id: 'SOCIEDADE_DE_ECONOMIA_MISTA', nome: 'Sociedade de Economia Mista'},
      {id: 'INSTITUICAO_FINANCEIRA', nome: 'Instituição Financeira constituída sob a forma de Empresa Pública, Pessoa Jurídica de Direito Privado'},
      {id: 'SOCIEDADE_ANONIMA_ABERTA', nome: 'Sociedade Anônima Aberta'},
      {id: 'SOCIEDADE_ANONIMA_FECHADA', nome: 'Sociedade Anônima Fechada'},
      {id: 'SOCIEDADE_EMPRESARIA_LIMITADA', nome: 'Sociedade Empresária Limitada'},
      {id: 'SOCIEDADE_EMPRESARIA_EM_NOME_COLETIVO', nome: 'Sociedade Empresária em Nome Coletivo'},
      {id: 'SOCIEDADE_EMPRESARIA_EM_COMANDITA_SIMPLES', nome: 'Sociedade Empresária em Comandita Simples'},
      {id: 'SOCIEDADE_EMPRESARIA_EM_COMANDITA_POR_ACOES', nome: 'Sociedade Empresária em Comandita por Ações'},
      {id: 'SOCIEDADE_EM_CONTA_DE_PARTICIPACAO', nome: 'Sociedade em Conta de Participação'},
      {id: 'SOCIEDADE_UNIPESSOAL_LIMITADA', nome: 'Sociedade Unipessoal Limitada'},
      {id: 'MEI', nome: 'Empresário Individual'},
      {id: 'COOPERATIVA', nome: 'Cooperativa'},
      {id: 'CONSORCIO_DE_SOCIEDADES', nome: 'Consórcio de Sociedades'},
      {id: 'GRUPO_DE_SOCIEDADES', nome: 'Grupo de Sociedades'},
      {id: 'SOCIEDADE_ESTRANGEIRA', nome: 'Estabelecimento, no Brasil, de Sociedade Estrangeira'},
      {id: 'EMPRESA_BINACIONAL_ARGENTINA', nome: 'Estabelecimento, no Brasil, de Empresa Binacional Argentino-Brasileira'},
      {id: 'EMPRESA_DOMICILIADA_NO_EXTERIOR', nome: 'Empresa Domiciliada no Exterior'},
      {id: 'CLUBE_FUNDO_DE_INVESTIMENTO', nome: 'Clube/Fundo de Investimento'},
      {id: 'SOCIEDADE_SIMPLES_PURA', nome: 'Sociedade Simples Pura'},
      {id: 'SOCIEDADE_SIMPLES_LIMITADA', nome: 'Sociedade Simples Limitada'},
      {id: 'SOCIEDADE_SIMPLES_EM_NOME_COLETIVO', nome: 'Sociedade Simples em Nome Coletivo'},
      {id: 'SOCIEDADE_SIMPLES_EM_COMANDITA_SIMPLES', nome: 'Sociedade Simples em Comandita Simples'},
      {id: 'EMPRESA_BINACIONAL', nome: 'Empresa Binacional'},
      {id: 'CONSORCIO_DE_EMPREGADORES', nome: 'Consórcio de Empregadores'},
      {id: 'CONSORCIO_SIMPLES', nome: 'Consórcio Simples'},
      {id: 'EIRELI', nome: 'Empresa Individual de Responsabilidade Limitada (de Natureza Empresária)'},
      {id: 'EIRELI_SIMPLES', nome: 'Empresa Individual de Responsabilidade Limitada (de Natureza Simples)'},
      {id: 'SOCIEDADE_UNIPESSOAL_DE_ADVOGADOS', nome: 'Sociedade Unipessoal de Advogados'},
      {id: 'COOPERATIVAS_DE_CONSUMO', nome: 'Cooperativas de Consumo'},
      {id: 'ORGANIZACAO_RELIGIOSA', nome: 'Organização Religiosa'},
      {id: 'ASSOCIACAO_PRIVADA', nome: 'Associação Privada'},
      {id: 'ORGANIZACAO_INTERNACIONAL', nome: 'Organização Internacional'},
      {id: 'REPRESENTACAO_DIPLOMATICA_ESTRANGEIRA', nome: 'Representação Diplomática Estrangeira'},
      {id: 'OUTRAS_INSTITUICOES_EXTRATERRITORIAIS', nome: 'Outras Instituições Extraterritoriais'},
      {id: 'OUTRAS', nome: 'Outras'},
    ]
  },

  getNaturezaJuridicaOnrtdpj() {
    return [
      {id: 'ASSOCIACAO', nome: '1 - Associação'},
      {id: 'SOCIEDADE', nome: '2 - Sociedade'},
      {id: 'FUNDACAO', nome: '3 - Fundação'},
      {id: 'ORGANIZACAO_RELIGIOSA', nome: '4 - Organização Religiosa'},
      {id: 'PARTIDO_POLITICO', nome: '5 - Partido Político'},
      {id: 'EMPRESA_INDIVIDUAL_RESPONSABILIDADE_LIMITADA', nome: '6 - Empresa individual de responsabilidade limitada'},
      {id: 'MATRICULA', nome: '7 - Matrícula (Lei 6015/1973, art. 116, II)'},
      {id: 'EMPRESA_SIMPLES_CREDITO', nome: '8 - Empresa simples de crédito'},
    ]
  },

  getSexos() {
    return [
      {id: 'MASCULINO', nome: 'Masculino'},
      {id: 'FEMININO', nome: 'Feminino'},
      {id: 'INDEFINIDO', nome: 'Indefinido'},
      {id: 'PREFIRO_NAO_IDENTIFICAR', nome: 'Prefiro Não Identificar'},
    ]
  },

  getRegimesOld() {
    return [
      {id: 'COMUNHAO_PARCIAL', nome: 'Comunhão Parcial'},
      {id: 'COMUNHAO_UNIVERSAL', nome: 'Comunhão Universal'},
      {id: 'SEPARACAO_TOTAL', nome: 'Separação Total'},
      {id: 'PARTICIPACAO_FINAL_AQUESTOS', nome: 'Participação Final nos Aquestos'},
      {id: 'SEPARACAO_OBRIGATORIA', nome: ' Separação Obrigatória'},
      {id: 'CASAMENTO_EXTERIOR', nome: ' Casamento no Exterior'}
    ]
  },

  getRegimes() {
    return [
      {id: 'COMUNHAO_PARCIAL', nome: 'Comunhão Parcial de Bens', descricao: 'pelo regime da comunhão parcial'},
      {id: 'COMUNHAO_UNIVERSAL', nome: 'Comunhão Universal de Bens', descricao: 'pelo regime da comunhão universal'},
      {id: 'PARTICIPACAO_FINAL_AQUESTOS', nome: 'Participação Final nos Aquestos', descricao: 'pelo regime de participação final nos aquestos'},
      {id: 'SEPARACAO_OBRIGATORIA', nome: 'Separação Obrigatória de Bens', descricao: 'pelo regime da separação obrigatória'},
      {id: 'SEPARACAO_TOTAL', nome: 'Separação Total', descricao: 'pelo regime da separação total'},
      {id: 'CASAMENTO_EXTERIOR', nome: 'Casamento no Exterior', descricao: ''},
      {id: 'DESCONHECIDO', nome: 'Desconhecido', descricao: ''},
    ]
  },

  getNacionalidades() {
    return VueBusiness.getVueRoot().enums?.EnumNacionalidade || []
  },

  getLabelPais(idNacionalidade){
    let nacionalidades = this.getNacionalidades();
    nacionalidades = nacionalidades.filter(n => n.id === idNacionalidade);
    if(nacionalidades.length === 1){
      return nacionalidades[0].pais;
    }
    return "";
  },

  getTiposPessoa() {
    return [
      {id: 'FISICA', nome: 'Pessoa Física'},
      {id: 'JURIDICA', nome: 'Pessoa Jurídica'}
    ]
  },

  getTiposCadastro(isRI, isRTD, isRCPJ, isNotas){
    let options = [];

    if(isRI){
      options.push({id: 'indicadorRI', nome: 'Indicador Pessoal RI'});
    }

    if(isRTD){
      options.push({id: 'indicadorRTD', nome: 'Indicador Pessoal RTD'});
    }

    if(isRCPJ){
      options.push({id: 'indicadorRCPJ', nome: 'Indicador Pessoal RCPJ'});
    }

    if(isNotas){
      options.push({id: 'indicadorTN', nome: 'Indicador Pessoal TN'});
    }

    return options;
  },

  getEstadosCivil() {
    return VueBusiness.getVueRoot().enums?.EnumEstadoCivil || []
  },

  getTipoSeparacao() {
    return VueBusiness.getVueRoot().enums?.EnumTipoSeparacao || []
  },

  getUniaoEstavel() {
    return [
      {id: 'SIM', nome: 'Sim'},
      {id: 'NAO', nome: 'Não'},
      {id: 'DESCONHECIDO', nome: 'Não Informado'}
    ]
  },

  indicadorPessoalIsEstrangeiro(indicadorPessoalVersao){
    const tipoPessoal = indicadorPessoalVersao?.indicadorPessoal?.tipoPessoa || indicadorPessoalVersao.tipoPessoa;
    if(tipoPessoal === 'FISICA'){
      return indicadorPessoalVersao.nacionalidade !== 'BRASIL';
    }else if(tipoPessoal === 'JURIDICA') {
      return !!indicadorPessoalVersao.possuiParticipacaoEstrangeira;
    }
  },

  validarEndereco(pessoa){
    let campos = ['cidade', 'pais'];
    if(pessoa.pais == 'BRASIL'){
      campos.push('estado');
    }

    campos = campos.filter(c => {
      return Utils.isEmptyNullOrUndefined(pessoa[c])
    });

    return campos;

  },

  async validarEmail(email) {
    if (email) {
      return Http.get(`${path}/public/validar/email?email=${encodeURIComponent(email)}`);
    }
    return "E-mail inválido";
  },

  async validarFirma(id) {
    return Http.post(`${path}/${id}/validar-firma`);
  },

  async gerarFirma(id, servicoId) {
    const query = servicoId ? `?servicoId=${servicoId}` : '';
    return Http.post(`${path}/${id}/gerar-firma${query}`);
  },

  camposConsulta() {
    let options = [{id: true, nome: 'Sim'}, {id: false, nome: 'Não'}];
    return Utils.orderBy([
      {id: 'nome', nome: 'Nome', type: 'text'},
      {id: 'tipo_pessoa', nome: 'Tipo de Pessoa', type: 'list', options: this.getTiposPessoa()},
      {id: 'tipo_cadastro', nome: 'Tipo de Cadastro'},
      {id: 'livro', nome: 'Livro'},
      {id: 'documento_cpf', nome: 'CPF', type: 'cpf'},
      {id: 'documento_cnpj', nome: 'CNPJ', type: 'cnpj'},
      {id: 'rg', nome: 'RG', type: 'text'},
      {id: 'orgao_emissor', nome: 'Órgão Emissor', type: 'text'},
      {id: 'cnh', nome: 'CNH', type: 'text'},
      {id: 'cip', nome: 'Identidade Profissional', type: 'text'},
      {id: 'passaporte', nome: 'Passaporte', type: 'text'},
      {id: 'outros_documentos', nome: 'Outros Documentos', type: 'text'},
      {id: 'falecido', nome: 'Pessoa Falecida', type: 'list', options},
      {id: 'firma', nome: 'Firma', type: 'number'},
      {id: 'firma_registrada', nome: 'Firma Registrada', type: 'list', options: [{id: true, nome: 'Sim'}, {id: false, nome: 'Não'}]},
      {id: 'menor', nome: 'Menor de Idade', type: 'list', options},
      {id: 'incapaz', nome: 'Incapaz', type: 'list', options},
      {id: 'exposta_politicamente', nome: 'Pessoa Exposta Politicamente', type: 'list', options},
      {id: 'pessoa_obrigada', nome: 'Pessoa Obrigada', type: 'list', options},
      {id: 'servidor_publico', nome: 'Servidor Público', type: 'list', options},
      {id: 'possui_participacao_estrangeira', nome: 'Participação Estrangeira', type: 'list', options},
      {id: 'nascimento', nome: 'Data de Nascimento', type: 'date'},
      {id: 'cadastro', nome: 'Data Cadastro', type: 'date'},
      {id: 'atualizacao_manual', nome: 'Data de Alteração Manual', type: 'date'},
      {id: 'registro', nome: 'Data Registro', type: 'date'},
      {id: 'sequencial', nome: 'Sequencial', type: 'text'},
      {id: 'sexo', nome: 'Sexo', type: 'list', options: this.getSexos()},
      {id: 'nacionalidade', nome: 'Nacionalidade', type: 'text'},
      {id: 'profissao', nome: 'Profissão', type: 'text'},
      {id: 'nome_pai', nome: 'Nome do Pai', type: 'text'},
      {id: 'nome_mae', nome: 'Nome da Mãe', type: 'text'},
      {id: 'estado_civil', nome: 'Estado Civil', type: 'list', options: this.getEstadosCivil()},
      {id: 'possui_uniao_estavel', nome: 'União Estável', type: 'list', options: this.getUniaoEstavel()},
      {id: 'email', nome: 'E-mail', type: 'text'},
      {id: 'telefone', nome: 'Telefone', type: 'telefone'},
      {id: 'celular', nome: 'Celular', type: 'telefone'},
      {id: 'comercial', nome: 'Comercial', type: 'telefone'},
      {id: 'cep', nome: 'CEP', type: 'cep'},
      {id: 'logradouro', nome: 'Logradouro (rua) ', type: 'text'},
      {id: 'numero', nome: 'Número', type: 'text'},
      {id: 'quadra', nome: 'Quadra', type: 'text'},
      {id: 'lote', nome: 'Lote', type: 'text'},
      {id: 'bairro', nome: 'Bairro (setor)', type: 'text'},
      {id: 'cidade', nome: 'Cidade', type: 'text'},
      {id: 'pais', nome: 'País', type: 'list', options: this.getNacionalidades().map(n => ({id: n.id, nome: n.pais}))},
      {id: 'estado', nome: 'Estado', type: 'list', options: EnderecoBusiness.getEstados()},
      {id: 'complemento', nome: 'Complemento', type: 'text'},
      {id: 'observacao', nome: 'Observações', type: 'text'},
      {id: 'denominacao', nome: 'Nome Fantasia (Denominação)', type: 'text'},
      {id: 'inscricao_estadual', nome: 'Inscrição Estadual', type: 'text'},
      {id: 'inscricao_municipal', nome: 'Inscrição Municipal', type: 'text'},
      {id: 'natureza_juridica', nome: 'Natureza Jurídica', type: 'list', options: this.getNaturezaJuridica()},
    ], 'nome');
  },

}
